module.exports = __webpack_public_path__ + "img/asx.39da1e65.png";